// Vue 3 new object creation
import { createApp } from 'vue';
import { nextTick } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import {createBootstrap} from 'bootstrap-vue-next'
import App from './components/App.vue';
import Principal from './components/Principal.vue';
import acercade from './components/acerca-de.vue';
import Contacto from './components/Contacto.vue';
import ASFAdminDashboard from './components/admin/ASFAdminDashboard.vue'; // Importar el nuevo componente del dashboard
import ASFAdminLogin from './components/admin/ASFAdminLogin.vue'; // Importar el componente de login
import BlogAdminPageNoAuth from './components/admin/blog/BlogAdminPageNoAuth.vue'; // Importar el nuevo componente sin auth
import ImageAdminPageNoAuth from './components/admin/images/ImageAdminPageNoAuth.vue'; // Importar el nuevo componente sin auth
import Aos from 'aos';
// bootstrapVue is EOL, we migrate to bootstrap-vue-next
import {Cookiexe} from './cookiesAccept.js';
// La importación de bootstarp se realiza a través del fichero main.scss donde
// Primero se peronsalizan los estilos y luego importamos scss.
import './main.scss';

import 'aos/dist/aos.css';
import './css/theme.css';
import './css/cookiealert.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'; // Mover esta importación al final de los estilos

// Import FontAwesome core and icon components
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import the icons you want to use from FontAwesome
import { faBars, faBell, faNewspaper, faPenToSquare, faTreeCity, faPeopleGroup, faHandHoldingHeart, faClipboardCheck, faUpload, faTrashCan, faPlus} from '@fortawesome/free-solid-svg-icons';
import { faBuildingNgo, faLock, faLockOpen, faSpellCheck, faUsersGear} from '@fortawesome/free-solid-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';

// Add icons to the library
library.add(faBars, faBell, faFacebook, faNewspaper, faPenToSquare, faTreeCity, faPeopleGroup, faClipboardCheck, faUpload, faTrashCan, faPlus)
library.add(faHandHoldingHeart, faBuildingNgo, faLock, faLockOpen, faSpellCheck, faUsersGear);

// create an instance using the function, Vue3
const app = createApp(App)

// Launch Aos
Aos.init();

// Launch BootstrapVueNext
// Launch BootstrapVueNext
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Importar el bundle completo de JS de Bootstrap antes de inicializar BootstrapVueNext
app.use(createBootstrap());

// Register FontAwesome component globally
app.component('font-awesome-icon', FontAwesomeIcon);

import { BNavbar, BNavbarBrand, BNavbarToggle, BCollapse, BNavbarNav, BNavItem, BContainer, BFormInput, BButton, BFormSelect, BNavItemDropdown, BModal, BSpinner, BImg, BAlert } from 'bootstrap-vue-next';

// Register the components globally
app.component('BNavbar', BNavbar);
app.component('BAlert', BAlert);
app.component('BNavbarBrand', BNavbarBrand);
app.component('BNavbarToggle', BNavbarToggle);
app.component('BCollapse', BCollapse);
app.component('BNavbarNav', BNavbarNav);
app.component('BNavItem', BNavItem);
app.component('BContainer', BContainer);
app.component('BFormInput', BFormInput);
app.component('BButton', BButton);
app.component('BFormSelect', BFormSelect);
app.component('BNavItemDropdown', BNavItemDropdown);
app.component('BModal', BModal);
app.component('BSpinner', BSpinner);
app.component('BImg', BImg);

  // Creating Vue 3 routes
  const routes = [
        {
            path:'/',
            name: 'principal',
            component: Principal,
        },
        {
            path:'/acerca-de',
            component: acercade
        },
        {
            path:'/contacto',
            name:'contacto',
            component: Contacto
        },
        // --- Rutas de Píldoras ---
        {
            path: '/pildoras',
            component: () => import('./components/PildorasPage.vue'),
            children: [
                {
                    path: 'temporada/:temporada',
                    name: 'TemporadaVideos',
                    component: () => import('./components/TemporadaVideos.vue'),
                    props: true // Pasa el parámetro 'temporada' como prop
                },
                {
                    path: 'extras',
                    name: 'ExtrasVideos',
                    component: () => import('./components/ExtrasVideos.vue')
                },
                 {
                    path: '', // Ruta por defecto para /pildoras
                    redirect: { name: 'TemporadaVideos', params: { temporada: '1' } }
                }
            ]
        },
        // --- Fin Rutas de Píldoras ---

        // --- Rutas del Blog ---
        {
            path: '/blog',
            name: 'BlogList',
            // Lazy loading del componente
            component: () => import('./components/blog/BlogPage.vue')
        },
        {
            path: '/blog/:slug', // Usamos un parámetro dinámico para el slug
            name: 'BlogPostDetail',
            // Lazy loading y pasar props de la ruta al componente
            component: () => import('./components/blog/BlogPostDetail.vue'),
            props: true // Permite que el componente reciba 'slug' como prop
        },
        // --- Fin Rutas del Blog ---

        // --- Ruta de Administración del Blog ---
        // NO AÑADIR AL MENÚ PRINCIPAL - Acceso directo por URL
        // --- Ruta de Administración de Imágenes ---
        // NO AÑADIR AL MENÚ PRINCIPAL - Acceso directo por URL
        // --- Fin Ruta de Administración de Imágenes ---

        // --- Rutas del Panel de Administración ASF ---
        {
            path: '/ASFadmin',
            name: 'ASFAdminLogin',
            component: ASFAdminLogin
        },
        {
            path: '/ASFadmin/dashboard',
            name: 'ASFAdminDashboard',
            component: ASFAdminDashboard,
            meta: { requiresAuth: true }, // Esta ruta y sus hijos requieren autenticación
            children: [
                {
                    path: 'blog', // Ruta hija para gestión de blog (ahora con Auth)
                    name: 'ASFAdminBlog',
                    component: BlogAdminPageNoAuth, // Reutilizamos el componente, ahora protegido
                    meta: { requiresAuth: true }
                },
                {
                    path: 'images', // Ruta hija para gestión de imágenes (ahora con Auth)
                    name: 'ASFAdminImages',
                    component: ImageAdminPageNoAuth, // Reutilizamos el componente, ahora protegido
                    meta: { requiresAuth: true }
                },
                {
                    path: 'users', // Nueva ruta para la gestión de usuarios
                    name: 'ASFAdminUsers',
                    component: () => import('./components/admin/UserAdminPage.vue'), // Lazy load del nuevo componente
                    meta: { requiresAuth: true, requiresAdmin: true } // Requiere autenticación y rol de admin
                },
                {
                    path: '', // Redirigir a blog por defecto dentro del panel
                    redirect: { name: 'ASFAdminBlog' }
                }
            ]
        }
        // --- Fin Rutas del Panel de Administración ASF ---
    ]


// Creating Vue 3 Routes
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// Navegación de guardia global
router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('jwt_token');
    const userRole = localStorage.getItem('user_role');

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            // Si la ruta requiere autenticación y el usuario no está autenticado, redirigir al login
            next({ name: 'ASFAdminLogin' });
        } else {
            // Si la ruta requiere rol de administrador y el usuario no es admin
            if (to.matched.some(record => record.meta.requiresAdmin) && userRole !== 'admin') {
                // Puedes redirigir a una página de "Acceso Denegado" o al dashboard
                next({ name: 'ASFAdminDashboard' }); // O a una página de error de permisos
            } else {
                next(); // Continuar a la ruta
            }
        }
    } else {
        next(); // No requiere autenticación, continuar
    }
});

  // Vue 3 mounting app component
app.use(router).mount('#app');

// Call Cookiexe after the app has mounted
// Call Cookiexe after the app has fully mounted and DOM is updated
nextTick(() => {
    Cookiexe();
});
